/** Internal dependencies */
import { prepareApiCall } from './prepareApiCall';

export function handleButtonFilters(e) {
    const target = e.target.closest('button');
    if (!target) {
        return;
    }

    e.preventDefault();
    const parent = target.closest('[data-rest]');
    const isSelected = target.getAttribute('aria-pressed') === 'true';
    const isReset = target.dataset.filter === 'reset';

    if (isReset) {
        // handled in its own listener
        return;
    } else if (isSelected) {
        // This means we want to remove the filter
        target.setAttribute('aria-pressed', 'false');
        target.classList.remove('active');
    } else {
        // Make the filter selected
        target.setAttribute('aria-pressed', 'true');
        target.classList.add('active');
    }

    prepareApiCall(parent);
}
